export async function sendWhatsappTextMessage(httpClient, payload) {
  if (!httpClient || typeof httpClient.post !== 'function') {
    throw new Error('HTTP client is not available')
  }

  return httpClient.post(
    process.env.VUE_APP_API_BASE + '/whatsapp/send-message/',
    payload,
  )
}

export async function sendWhatsappMediaMessage(httpClient, payload) {
  if (!httpClient || typeof httpClient.post !== 'function') {
    throw new Error('HTTP client is not available')
  }

  return httpClient.post(
    process.env.VUE_APP_API_BASE + '/whatsapp/send-media/',
    payload,
  )
}
